import React from "react";
import "../stylesheets/Footer.css";

const Footer = () => {
    return (
        <section className="footer">
            <h4>Morgan Williamson | 2021</h4>
            <a className="repo" href="https://github.com/MorganWilliamson/u4-portfolio" rel="noreferrer" target="_blank" >GitHub Repo</a>
        </section>
    )
}

export default Footer;
